// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autoCompleteMotes {
  resize: vertical;
  width: calc(100% - 20px);
  background: transparent;
  padding: 2px;
}
.autoCompleteMotes .show-bg {
  resize: vertical;
  width: 100%;
  padding-top: 5px;
  margin: 0px 0;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background-color: white;
  position: relative;
  min-height: 22px;
  cursor: text;
}
.autoCompleteMotes .show-bg .motes-chip {
  background: #313131;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/auto-complete/auto-complete-motes/auto-complete-motes.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,wBAAA;EACA,uBAAA;EACA,YAAA;AACJ;AACI;EACI,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,0CAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AACR;AACQ;EACI,mBAAA;AACZ","sourcesContent":[".autoCompleteMotes {\n    resize: vertical;\n    width: calc(100% - 20px);\n    background: transparent;\n    padding: 2px;\n\n    .show-bg {\n        resize: vertical;\n        width: 100%;\n        padding-top: 5px;\n        margin: 0px 0;\n        border: 1px solid rgba(255, 255, 255, 0.3);\n        background-color: white;\n        position: relative;\n        min-height: 22px;\n        cursor: text;\n\n        .motes-chip {\n            background: #313131;\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
